<ng-container *ngIf="expandedItems.length > 0">
  <div class="expanded-items">
    <ng-container *ngFor="let item of expandedItems; trackBy: trackItem">
      <sn-action-list-item [item]="item" [context]="context"></sn-action-list-item>
    </ng-container>
  </div>
</ng-container>

<ng-container *ngIf="collapsedItems?.length">
  <sn-icon-button icon="more_vert" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
  </sn-icon-button>

  <mat-menu #menu="matMenu">
    <sn-menu [items]="collapsedItems" [context]="context"></sn-menu>
  </mat-menu>
</ng-container>
